import * as THREE from "three";


export default function animateTo(sectionId, props = {}) {
    return new Promise(async (resolve, reject) => {
        // console.log(sectionId?.sectionId)
        if(!sectionId) {
            resolve()
            console.warn("No sectionId")
            return
        }
        
        const threeViewer = window.threeViewer;
        const {controls, scene, product, center, isMobile} = threeViewer;
        
        
        // Create reusable vectors
        const v1 = new THREE.Vector3(0, 0, 1);
        const centerVector = new THREE.Vector3(0, 0, 0);
        
        // Initial values
        
        const object = scene.children.find(s => s.userData.id === sectionId);
        
        if(!object) {
            resolve()
            console.warn("No object found")
            return
        }
        
        let isAnimation = props.duration !== undefined ? props.duration > 0 : true;
        const duration = props.duration !== undefined ? props.duration : 0.25;
        
        // Get the radial angle of the object or props
        const angleSection = object?.userData?.radialAngle || props?.radialAngle || 0;
        
        
        // Rotate the vector around bottle Y axis by the specified angle
        v1.applyAxisAngle(new THREE.Vector3(0, 1, 0), angleSection);
        
        // Calculate the center of the bounding box of the section
        object.geometry.computeBoundingBox();
        let bBox = object.geometry.boundingBox;
        bBox.getCenter(centerVector);
        
        // Calculate the desired camera position based in the center and the rotated vector
        let cameraPos = center.clone().add(v1);
        
        const fit = props?.fit ? props?.fit : false;
        controls.setOrbitPoint(
            0,
            fit ? object.point.y : center.y,
            0
        )
        
        
        let target = controls.getTarget().clone()
        
        
        const options = props?.options || {
            paddingTop: 0.01,
            paddingBottom: fit ? 0.05 : 0.07,
            paddingLeft: 0.04,
            paddingRight: 0.04,
        }
        
        
        const fitObject = props?.fit ? object : product
        
        // controls.smoothTime = duration / 2
        // Target X & Z should be 0 for center rotation
        controls.setLookAt(cameraPos.x, cameraPos.y, cameraPos.z, 0, target.y, 0, isAnimation).then(() => {
            // controls.smoothTime = duration / 1.5
            target = controls.getTarget().clone()
            controls.setTarget(0, target.y, 0, isAnimation)
        })
        
        // controls.smoothTime = duration / 1.5
        
        // To center the object in the screen
        // Remove the bracket and other things from the calculation of the box
        let box = new THREE.Box3().setFromObject(fitObject)
        // Find max value from min and max X and Z
        let max = Math.max(box.max.x, box.max.z, Math.abs(box.min.x), Math.abs(box.min.z))
        box.max.x = box.max.z = max
        box.min.x = box.min.z = -max

        controls.fitToBox(box, isAnimation, options).then(async () => {
            target = controls.getTarget().clone()
            controls.setTarget(0, target.y, 0, isAnimation).then(() => {
                // controls.smoothTime = 0.1
                resolve()
            })
            
        })
        //target = controls.getTarget().clone()
        
        // setTimeout(() => {
        //     isResolved = true
        //     resolve()
        // }, duration * 500);
    })
}


/*
export function pixelToMilimeter(pixelLength) {
    const threeViewer = window.threeViewer;
    const {camera, controls} = threeViewer;
    
    
    // Calculate the depth as the distance from the camera to the controls target
    const depth = camera.position.distanceTo(controls.target);
    
    // Convert vertical field of view to radians
    const vFOV = THREE.MathUtils.degToRad(camera.fov);
    
    // Calculate the height of the visible area at the given depth
    const height = 2 * Math.tan(vFOV / 2) * depth;
    
    // Calculate the width of the visible area based on the aspect ratio
    const width = height * camera.aspect;
    
    // Calculate the size of a single pixel in world units (using width or height depending on the aspect ratio)
    const pixelSize = camera.aspect >= 1 ? width / threeViewer.clientWidth : height / threeViewer.clientHeight;
    
    // Convert the pixel length to world units
    const worldLength = pixelLength * pixelSize;
    
    // Assuming your world units are in meters, convert to millimeters
    return worldLength ;
}

function getTheGap (domId, position) {
    const domElement = document.getElementById(domId)
    
    if (domElement) {
      
        const size = domElement.clientHeight + parseFloat(getComputedStyle(domElement)[position])
      
        
        return Number(pixelToMilimeter(size).toFixed(2))
    } else {
        return 0.01
    }
}*/
